export const stageOptions = [
  { value: "novo", label: "New" },
  { value: "contato_iniciado", label: "Contacted" },
  { value: "qualificacao", label: "Qualified" },
  { value: "sem_resposta", label: "No Response" },
];

export const isValidStage = (value?: string | null) =>
  stageOptions.some((option) => option.value === value);

export const noteTypeOptions = [
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "meeting", label: "Meeting" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "note", label: "Note" },
];

export const finalClientTypeOptions = [
  { value: "aviation", label: "Aviation" },
  { value: "beauty", label: "Beauty" },
  { value: "corporate", label: "Corporate" },
  { value: "direct_consumer", label: "Direct Consumer" },
  { value: "esg", label: "ESG" },
  { value: "event", label: "Event" },
  { value: "fashion", label: "Fashion" },
  { value: "food_and_beverage", label: "Food & Beverage" },
  { value: "government", label: "Government" },
  { value: "health", label: "Health" },
  { value: "marine", label: "Marine" },
  { value: "mice", label: "MICE" },
  { value: "sports", label: "Sports" },
  { value: "trade_show", label: "Trade Show" },
] as const;

export const getFinalClientTypeLabel = (value?: string | null) => {
  const found = finalClientTypeOptions.find((item) => item.value === value);
  return found ? found.label : value || "-";
};

export const getStageLabel = (value?: string | null) => {
  const found = stageOptions.find((s) => s.value === value);
  return found ? found.label : value || "-";
};

export const getStageBadgeVariant = (value?: string | null) => {
  switch (value) {
    case "novo":
      return "prospect_new";
    case "contato_iniciado":
      return "prospect_contacted";
    case "qualificacao":
      return "prospect_qualified";
    case "sem_resposta":
      return "prospect_no_response";
    default:
      return "secondary";
  }
};
